/**
 * Vuex getters for the "userauth" module.
 *
 * Thin state accessors exposing the current user/auth state and in-progress
 * signup fields as-is. `getUser` additionally JSON-parses `state.user` if it
 * was ever stored as a raw string.
 */
export default {
  getAuthUser: (state) => state.user,
  /** Same as `getAuthUser`, but defensively JSON-parses `state.user` if it's a string, returning `null` on invalid/missing data. */
  getUser: (state) => {
    let user = state.user;
    if(!user){
      return null
    }
    if(typeof user === 'string'){
      try {
        user = user ? JSON.parse(user) : null;
      } catch (error) {
        user = null;
      }
    }
    return user
  },
  getAuthError: (state) => state.error,
  getShowSmsCodeInput: (state) => state.showSmsCodeInput,
  getUserPhone: (state) => state.userPhone,
  getUserEmail: (state) => state.userEmail,
  getUserName: (state) => state.userName,
  getFirstName: (state) => state.firstName,
  getLastName: (state) => state.lastName,
  getBirthDate: (state) => state.birthDate,
  getReferralCode: (state) => state.referralCode,
  getUserCounty: (state) => state.county,
  getUserStreetAddress: (state) => state.streetAddress,
  getUserStreetAddress2: (state) => state.streetAddress2,
  getUserCity: (state) => state.city,
  getUserAddressState: (state) => state.addressState,
  getUserZipCode: (state) => state.zipCode,
  getAuthErrorNotification: (state) => state.authErrorNotification,
  getAuthStatus: (state) => state.authStatus,
};
